import { call, put, takeLatest } from 'redux-saga/effects';
import { apiCall } from '../config/axios';
import {
  ERROR_VIEW_STATS,
  START_VIEW_STATS,
  SUCESS_VIEW_STATS,
} from '../types';

function* getStats(action) {
  try {
    const { menu_id, foreign_id } = action.payload;

    const response = yield call(
      apiCall,
      'get',
      `/generalsummaryreports/stats/${menu_id}/${foreign_id}`
    );

    if (response.data.error) throw new Error(response.data.msg);

    const data = response.data;

    if (data?.menu_id === Number(menu_id) && data?.foreign_id === foreign_id) {
      yield put({
        type: SUCESS_VIEW_STATS,
        payload: {
          foreign_id,
          stats: {
            times_viewed: data.times_viewed,
            times_clicked: data.times_clicked,
            times_displayed: data.times_displayed,
          },
        },
      });
    }
  } catch (error) {
    yield put({ type: ERROR_VIEW_STATS, payload: error.message });
  }
}

export function* watchFetchStats() {
  yield takeLatest(START_VIEW_STATS, getStats);
}
